module.exports = __webpack_public_path__ + "static/media/45GovernorsLibrary.d5a7bb90.jpg";